<div class="modal-window" tabindex="-1" role="dialog">
  <div class="modal-header">
    <h2 class="modal-title" data-test-id="modal-title">
      {{ 'CROP_IMAGE_TITLE' | translate }}
    </h2>
    <button
      type="button"
      class="unstyled-button"
      [attr.id]="'modal-btn-close-cross'"
      aria-label="Close"
      data-test-id="modal-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>

  <div class="modal-body h-400" data-test-id="wrap-image-cropper">
    <image-cropper
      [imageFile]="modalArguments.file"
      [cropperMinWidth]="CROPPER_WIDTH"
      [cropperMinHeight]="CROPPER_HEIGHT"
      [resizeToWidth]="CROPPER_WIDTH"
      [resizeToHeight]="CROPPER_HEIGHT"
      [aspectRatio]="1 / 1"
      output="base64"
      (imageCropped)="imageCropped($event)"
    ></image-cropper>
  </div>

  <div class="modal-footer" data-test-id="modal-footer">
    <button type="'button'" class="btn btn-primary" (click)="confirmAction()" [attr.data-test-id]="'modal-btn-save'">
      {{ 'BTN_SAVE_PROFILE_IMAGE_HINT' | translate }}
    </button>
    <button type="'button'" class="btn btn-secondary" (click)="closeDialog()" [attr.data-test-id]="'modal-btn-cancel'">
      {{ 'BTN_CANCEL_HINT' | translate }}
    </button>
  </div>
</div>
